import React from 'react'
import { MdCheckCircle } from 'react-icons/md'
import Footer from '../component/footer'
import Header from '../component/header'
import ThirdImg from '../Images/Mask group3.png'

const SpringPhase2 = () => {
  return (
      <div className='home_class'>
  
          <div className='overlapNav'>
          <Header/>
            <section className='about_us-container'>
              <div className="container aboutContainerOne">
                <div className="about_text-header">
                  <h1 className="wow animate__fadeInUp" data-wow-duration="1.8s">Spring View Estate Phase II</h1>
                  <p className=" wow animate__fadeInUp" data-wow-duration="3s">Discover the ultimate real estate opportunity in Oha—strategically located near key institutions that are set to transform the region. Spring View Estate is now in a prime position, surrounded by the upcoming College of Aviation, School of Science and Technology, and the proposed Police Academy.</p>
              </div>
            </div>
           </section>
          </div>
  
          <div className="springBanner">
              <img src={ThirdImg} alt="img" />
          </div>
  
          <div className="container">
            <div className="propertyDetail_text wow animate__fadeInUp" data-wow-duration="2s" data-wow-offset="150">
              <p>All our properties are totally free from government acquisition. Get allocation immediately after the payment. Flexible payment plans available for 3 months and 6 months. Everything you need is in Spring View Estate Buy now before the price increase.</p>
            </div>
          </div>
  
          <div className="container">
            <div className="propertyDetail_text wow animate__fadeInUp" data-wow-duration="2s" data-wow-offset="150">
              <p>This estate is tailored to meet your highest standards, with excellently designed luxury homes, that will bring you and your family comfort, peace and harmony.</p>
            </div>
          </div>
  
          <div className="container">
            <div className="propertyDetail_text wow animate__fadeInUp" data-wow-duration="2s" data-wow-offset="150">
              <p>Currently selling for 3 million naira per plot 465sqm and installment plan available.</p>
            </div>
          </div>
  
          <div className="container">
            <div className="propertyDetail_text wow animate__fadeInUp" data-wow-duration="2s" data-wow-offset="150">
              <h5>Title:</h5><p>Freehold, Registered Survey & Deed of conveyance</p>
            </div>
          </div>
  
          <div className="container">
            <div className="propertyDetail_text wow animate__fadeInUp" data-wow-duration="2s" data-wow-offset="150">
              
              <div className="estateCarrier">
                  <h5>Key Features:</h5>
                  <div className="estate_detail">
                  <div className='estate_pargraph'> <div className='mdCircle'><MdCheckCircle /></div> <div><p>Location: Oha, near Delta State University of Science and Technology</p> </div> </div>
                  
                  <div className='estate_pargraph'> <div className='mdCircle'><MdCheckCircle /></div> <div><p>Plot Details: 465SQM of 100% dry, tabletop land on a well-designed layout with excellent road connectivity</p> </div> </div>
                  
                  <div className='estate_pargraph'> <div className='mdCircle'><MdCheckCircle /></div> <div><p>Infrastructure: A 5-minute drive from Osubi Airport and near future educational and security institutions  </p> </div> </div>
                  
                  <div className='estate_pargraph'> <div className='mdCircle'><MdCheckCircle /></div> <div><p>a competitive investment opportunity in a rapidly growing area</p> </div> </div>
                  
                  {/* <div className='estate_pargraph'> <div className='mdCircle'><MdCheckCircle /></div> <div><p>Well-Designed Layout</p> </div> </div> */}
                  
                  {/* <div className='estate_pargraph'> <div className='mdCircle'><MdCheckCircle /></div> <div><p>Good Road Network</p></div> </div> */}
                  
                  {/* <div className='estate_pargraph'> <div className='mdCircle'><MdCheckCircle /></div> <div><p>Neighborhood: University of Delta State University of Science and Technology</p> </div> </div> */}
                  
                  {/* <div className='estate_pargraph'> <div className='mdCircle'><MdCheckCircle /></div> <div> <p>5-minute drive from Osubi Airport</p> </div> </div> */}
                  
                  {/* <div className='estate_pargraph'> <div className='mdCircle'><MdCheckCircle /></div> <div> <p>Proposed Police Academy nearby</p> </div> </div> */}

                  </div>
              </div>
              
              <div className="estateCarrier">
                  <h5>Why You Should Invest</h5>
                  <div className="estate_detail">
                  <div className='estate_pargraph'> <div className='mdCircle'><MdCheckCircle /></div> <div><p>Strategic Investment: Benefit from the rising demand driven by educational and security institutions.</p> </div> </div>
                  
                  <div className='estate_pargraph'> <div className='mdCircle'><MdCheckCircle /></div> <div><p>High Growth Potential: As the College of Aviation, School of Science and Technology, and Police Academy come online, expect strong capital appreciation </p> </div> </div>
                  
                  <div className='estate_pargraph'> <div className='mdCircle'><MdCheckCircle /></div> <div><p>Versatile Development: Ideal for residential or commercial projects with a secure and serene environment</p> </div> </div>
                  
                  <div className='estate_pargraph'> <div className='mdCircle'><MdCheckCircle /></div> <div><p> Proven Track Record: Backed by Grejahmi Homes' commitment to transparency, proper documentation, and secure payment plans</p> </div> </div>
                  
                  </div>
              </div>
  
              <div className="estateCarrier">
                  <h5>Payment Plan:</h5>
                  <div className="estate_detail_pay">
                  <div className='estate_pargraph'> <div className='mdCircle'><MdCheckCircle /></div> <div><p>Outright Payment: 3M Residential</p> </div> </div>
                  
                  <div className='estate_pargraph'> <div className='mdCircle'><MdCheckCircle /></div> <div><p>Flexible Payment Options Available (Contact us for details)</p> </div> </div>
                  
                  <div className='estate_pargraph'> <div className='mdCircle'><MdCheckCircle /></div> <div><p>3-6 months 3.2M</p> </div> </div>
                  
                  <div className='estate_pargraph'> <div className='mdCircle'><MdCheckCircle /></div> <div><p>one year 3.5m</p> </div> </div>
                  
                  <div className='estate_pargraph'> <div className='mdCircle'><MdCheckCircle /></div> <div><p>Actual Price commercial 4m</p> </div> </div>
                  </div>
              </div>
  
            </div>
          </div>
  
  
  
          
  
          <Footer/>
      </div>
  )
}

export default SpringPhase2